import messages from './cmsOrder.json' with { type: 'json' };

export const cmsOrderEn: Readonly<typeof messages> = messages;
